/**
 * Mobile JavaScript file for the WordPres theme
 *
 * This file only gets loaded if user is using a
 * mobile phone. It is loaded after main.js.
 *
 * @license        No license
 * (Without a license, the code is copyrighted by default.
 * People can read the code, but they have no legal right to use
 * it. To use the code, you must contact the author directly and
 * ask permission.)
 *
 * @author        Velten Media
 * @link        http://www.veltenmedia.nl
 * @email        info@veltenmedia.nl
 *
 * @file        mobile.js
 *
 * @copyright    (C) 2015, Velten Media
 */

jQuery(document).ready(function ($) {

    // Set doubleTapToGo on menu
    if ($('.nav ul li.menu-item-has-children').length && $.isFunction($.fn.doubleTapToGo)) {
        $('.nav ul li.menu-item-has-children').doubleTapToGo();
    }

});
